import PropTypes from 'prop-types'
import React, { Fragment, useContext, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { LoginContext } from './context/loginContext'
import { MenuContext } from './context/menuContext'

const MENU_AYUDA = 70
const CONVERTIR_TIENDA_OFICIAL = 39

const MenuPrincipal = (props) => {
  const { menus, desplegarMenu, menuAbierto, nav } = useContext(MenuContext)
  const { loginDataContext } = useContext(LoginContext)
  const [idMenuAbrir, setMenuAbrir] = useState(0)
  const [subMenuAbierto, setSubMenuAbierto] = useState(false)
  const tipoUsuario = loginDataContext.tipoUsuario

  // Reset submenu states when main menu closes
  useEffect(() => {
    if (!menuAbierto) {
      setMenuAbrir(0)
      setSubMenuAbierto(false)
    }
  }, [menuAbierto])

  const toggle = (idMenu) => {
    setMenuAbrir(idMenu)
    if (idMenu === idMenuAbrir) {
      setSubMenuAbierto(!subMenuAbierto)
    } else {
      setSubMenuAbierto(false)
    }
    if (idMenu === MENU_AYUDA) {
      props.mostrarAyuda()
    }
  }

  // Helper function to close menu when navigating
  const handleMenuNavigation = () => {
    desplegarMenu(false)
  }

  const mostrarMenu = (menuPrincipal) => {
    if (menuPrincipal.link) {
      return (
        <>
          {menuPrincipal.idMenu !== MENU_AYUDA ? (
            <Link
              to={`/${menuPrincipal.link}`}
              className="aside-menu-link"
              style={{ color: 'inherit', textDecoration: 'inherit' }}
              onClick={handleMenuNavigation}
            >
              {menuPrincipal.nombre}
            </Link>
          ) : (
            <span className="aside-menu-link">{menuPrincipal.nombre}</span>
          )}
        </>
      )
    } else {
      return menuPrincipal.nombre
    }
  }

  return (
    <nav
      ref={nav}
      className={`vertical_nav ocultarScroll ${
        menuAbierto ? 'vertical_nav__opened' : 'vertical_nav__closed'
      }`}
    >
      {/* Invisible overlay that captures clicks outside menu content */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'transparent',
          zIndex: 1
        }}
        onClick={() => {
          desplegarMenu(false)
        }}
      />

      {/* Menu content container */}
      <div
        style={{
          backgroundColor: '#5e80c8',
          borderRadius: '10px',
          padding: '20px',
          marginTop: '0.8em',
          marginLeft: '0.2em', // 0.5em from left edge
          marginRight: 'auto', // Allow right side to expand
          maxWidth: '600px',
          width: '90%',
          maxHeight: '80vh',
          overflowY: 'auto',
          position: 'relative',
          zIndex: 2 // Above the overlay
        }}
        onClick={(e) => {
          // Prevent menu from closing when clicking inside the menu content
          e.stopPropagation()
        }}
      >
        <ul>
          {menus
            .filter((menu) => menu.idMenuPosicion === 1 && menu.idMenuPadre === 0)
            .map((menuPrincipal) => (
              <Fragment key={menuPrincipal.idMenu}>
                <li
                  className="aside-menu-icon menuDesplegarMenu"
                  id={menuPrincipal.idMenu}
                  onClick={() => toggle(menuPrincipal.idMenu)}
                >
                  <i
                    className={`${menuPrincipal.icono} fa-fw`}
                    aria-hidden="true"
                    style={{ marginRight: '10px' }}
                  />
                  {menuAbierto && mostrarMenu(menuPrincipal)}
                </li>
                {menuPrincipal.idMenu === idMenuAbrir && !subMenuAbierto && (
                  <>
                    {tipoUsuario === 'R' ? (
                      <ul className="sub-menu">
                        {menus
                          .filter(
                            (menuS) =>
                              menuS.idMenuPadre === menuPrincipal.idMenu &&
                              menuS.idMenu !== CONVERTIR_TIENDA_OFICIAL
                          )
                          .map((subMenu) => (
                            <li key={subMenu.idMenu} id={subMenu.idMenu}>
                              {menuAbierto && (
                                <Link
                                  to={`/${subMenu.link}`}
                                  className=""
                                  onClick={handleMenuNavigation}
                                >
                                  {subMenu.nombre}
                                </Link>
                              )}
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <ul className="sub-menu">
                        {menus
                          .filter((menuS) => menuS.idMenuPadre === menuPrincipal.idMenu)
                          .map((subMenu) => (
                            <li key={subMenu.idMenu} id={subMenu.idMenu}>
                              {menuAbierto && (
                                <Link
                                  to={`/${subMenu.link}`}
                                  className=""
                                  onClick={handleMenuNavigation}
                                >
                                  {subMenu.nombre}
                                </Link>
                              )}
                            </li>
                          ))}
                      </ul>
                    )}
                  </>
                )}
              </Fragment>
            ))}
        </ul>
      </div>
    </nav>
  )
}

MenuPrincipal.propTypes = {
  mostrarAyuda: PropTypes.func.isRequired
}

export default React.memo(MenuPrincipal)
